import { createSlice } from '@reduxjs/toolkit';
import { fetchWebsiteSettings } from './WebsiteSettingsSlice';

const servicesSlice = createSlice({
  name: 'services',
  initialState: {
    services: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebsiteSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWebsiteSettings.fulfilled, (state, action) => {
        state.loading = false;
        // Filter services data from allSettings
        state.services = action.payload.allSettings.filter(item => item.type === 'service'); 
      })
      .addCase(fetchWebsiteSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectServices = (state) => state.services.services;
export default servicesSlice.reducer;

